var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config},scopedSlots:_vm._u([{key:"DETAILS",fn:function(ref){
var visible = ref.visible;
var params = ref.params;
return [(visible)?_c('Tracker',{attrs:{"statusId":params.row.airway_number}}):_vm._e()]}},{key:"PREVIEW",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
return [_c('img',{staticStyle:{"width":"100%"},attrs:{"visible":visible,"src":params.src}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }